import { ComponentSelectors, ComponentElements, UIComponent, ComponentInjector, ComponentObject, ComponentService} from '@atypon/ui-utils';

class Texts extends ComponentObject {}

class ClassList extends ComponentObject {}

class Selectors extends ComponentSelectors {
    ERPForm = '.ERP-acceptance form';
    submitBtn = '.ERP-acceptance .agree-submit';
    checkBoxTandC = '.ERP-acceptance .ERP-TandC';
    checkboxContainer = '.ERP-acceptance .checkbox--primary';
    errorContainer = '.ERP-acceptance .checkbox--primary span';
    redirectUriInput = '.ERP-acceptance input[name="redirectUri"]';
    cancelTandC = '#cancelTandC';
}

class Elements extends ComponentElements<Selectors> {
    ERPForm: HTMLFormElement ;
    submitBtn: HTMLElement ;
    checkBoxTandC: HTMLElement[] | null = null;
    checkboxContainers: HTMLElement[] | null = null;
}

interface ERPAcceptance extends ComponentService<Selectors, Elements, ClassList, Texts> {}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class ERPAcceptance implements UIComponent {


    initialize(): void {
        this.setElements();
        this.setRedirectUri();
        this.addEventListeners();
    }

    private setElements(): void {
        this.elements.ERPForm = this.domUtils.getElement(this.selectors.ERPForm);
        this.elements.submitBtn = this.domUtils.getElement(this.selectors.submitBtn);
        this.elements.checkBoxTandC = this.domUtils.getElements(this.selectors.checkBoxTandC);
        this.elements.checkboxContainers = this.domUtils.getElements(this.selectors.checkboxContainer);
    }

    addEventListeners(): void {
        this.elements.submitBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleSubmit();
        });

        this.elements.checkBoxTandC?.forEach((checkbox) => {
            checkbox.addEventListener('change', (e) => {
                this.checkBoxesChecker(e);
            });
        });
    }

    private setRedirectUri(): void {
        const redirectUriValue = this.findGetParameter();
        if (redirectUriValue) {
            const redirectInput = document.querySelector(this.selectors.redirectUriInput);
            const cancelLink = document.querySelector(this.selectors.cancelTandC);
            redirectInput?.setAttribute('value', redirectUriValue);
            cancelLink?.setAttribute('href', `/action/doLogout?redirectUri=${redirectUriValue}`);
        }
    }

     private  checkBoxesChecker(event: Event): void{
        const checkboxContainer = (event.target as HTMLElement).parentElement;
        let errorContainer;
        

        if (checkboxContainer) {
            const errorMsg= checkboxContainer.querySelector('.invalid-feedback');;
            errorContainer= checkboxContainer.querySelector('span');
            
            checkboxContainer.classList.remove('error');
            errorMsg?.remove();

        }

        errorContainer && errorContainer.classList.remove('error');
     }  


    private handleSubmit(): void {
        const uncheckedBoxes = this.elements.ERPForm?.querySelectorAll(
            'input[type="checkbox"]:not(:checked, .optional)'
        );

        if (uncheckedBoxes && uncheckedBoxes.length === 0) {
            this.elements.ERPForm?.submit();
        } else {
            uncheckedBoxes?.forEach((checkbox) => {
                const checkboxContainer = checkbox.parentElement;
                const errorContainer = checkboxContainer?.querySelector('span');

                if (checkboxContainer && !checkboxContainer.querySelector('.invalid-feedback')) {
                    const errorMsg = document.createElement('p');
                    errorMsg.classList.add('invalid-feedback');
                    errorMsg.textContent = 'You must accept to continue.';

                    errorContainer?.classList.add('error');
                    checkboxContainer.classList.add('error');
                    checkboxContainer.appendChild(errorMsg);
                }
            });
        }
    }

    private findGetParameter(): string | null {
        const redirectUriParameter= window.location.search.split('redirectUri=')
        const isExisted = redirectUriParameter?.length > 1;
        let uri= '/';
        uri= isExisted && decodeURIComponent(redirectUriParameter[1]);
        
        return uri;
    }
}

export default ERPAcceptance;

export {
    Texts as ERPAcceptanceTexts,
    ClassList as ERPAcceptanceClassList,
    Selectors as ERPAcceptanceSelectors,
    Elements as ERPAcceptanceElements,
};


